<template>
    <footer class="footer">
        <div class="wrap">
            <div class="footer_l">
                <div class="footer_lb">
                    <p>地址：北京市海淀区中关村大街22号中科大厦A座12层 | 邮编：100190</p>
                    <p>电话：010-68942688 转8001&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;传真：010-68948636</p>
                    <p>邮箱：fso@info-rae.cn</p>
                    <p>版权所有：俄罗斯工程院中国中心&nbsp;&nbsp;&nbsp;技术运营支持：环球英才网（北京）科技有限公司&nbsp;&nbsp;&nbsp;法律顾问：北京普贤律师事务所 丁涛
                    </p>
                    <p style="display: flex;">
                        <a href="https://beian.miit.gov.cn">京ICP备2022013886号-1 </a>

                        &nbsp;&nbsp;&nbsp;

                        <a class="footer_b" target="_blank"
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039424">
                            <img src="../../assets/images/wangan.png">京公网安备 11010802039424号
                        </a>

                    </p>
                </div>
            </div>

            <div class="footer_r">
                <a href="/newProjectList">
                    <img src="../../assets/images/code.jpg" style="width: 100px;height: 100px;">
                </a>
            </div>
        </div>
    </footer>
</template>
<script></script>
<style scoped>
    .footer {
        padding: 20px 0;
        background: #2a2a2a;
        color: #fff;
        font-size: 14px;
        line-height: 24px;
    }

    .wrap {
        display: flex;
        justify-content: space-between;
        width: 70%;
        margin: auto;
    }

    .footer_b {
        display: flex;
        align-items: center;
    }

    .footer_lb a {
        color: #939393;
        text-decoration: none;
        height: 20px;
        line-height: 20px;
    }
</style>